"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowMouseLink = void 0;
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var RowMouseLink = exports.RowMouseLink = _styledComponents["default"].div.withConfig({
  displayName: "RowMouseLink",
  componentId: "sc-hvecl1-0"
})(["position:absolute;z-index:0;inset:0;cursor:pointer;"]);